import { STREAM_STATUS_DISPLAY_MAP } from "constants/phase";

export const RATING_TYPES = {
  MANUAL: "MANUAL",
  AI: "AI",
};

export const TYPESENSE_HIDDEN_FACET_KEYS = {
  CATEGORY: "category",
};

export const TYPESENSE_SPORTS_STREAM_FACET_KEYS = {
  TOURNAMENTS: "tournamentName",
  TEAMS: "teams",
  PLAYERS: "players",
};

export const TYPESENSE_NEWS_STREAM_FACET_KEYS = {
  TV_CHANNEL: "tvChannel",
  TV_SHOW: "tvShow",
};

export const TYPESENSE_COMMON_STREAM_FACET_KEYS = {
  STATUS: "status",
  DATE_RANGE: "dateRange",
  WORKSPACES: "sharedWorkspaces",
  SORT_BY: "sortBy",
  ASPECT_RATIO: "aspectRatio",
};

export const TYPESENSE_CLIP_FACET_KEYS = {
  EVENTS: "events",
  PLAYERS: "players",
  RATING: "rating",
  RATING_TYPE: "ratingType",
  MANUAL_RATING: "manualRating",
  ASPECT_RATIO: "aspectRatio",
  IS_BOOKMARKED: "isBookmarked",
  TEAMS: "teams",
  CLIP_AUDIOS: "clipLanguage",
  SORT_BY: "sortBy",
  DURATION: "duration",
  WEBHOOK_STATUS: "cmsPublish",
  PLAYBACK_SPEED: "playbackSpeed",
  IS_MANUAL_UPLOAD: "isManualUpload",
  IS_ILLUSTO_CLIP: "isIllustoClip",
  IS_ILLUSTO_TEMPLATE: "isIllustoTemplate",
  IS_DATAFEED_CLIP: "isDatafeedClip",
  IS_MANUAL: "isManual",
  IS_TAGGED: "isTagged",
  IS_UNTAGGED: "isUntagged",
  IS_ADDED_TO_CLIPS_PAGE: "isAddedToClipsPage",
  IS_DRAFT: "isDraft",
  IS_ROLLBACKED: "isRollbacked",
};

export const TYPESENSE_CLIP_SPORTS_FACET_KEYS = {
  TEAMS: "teams",
  PLAYERS: "players",
  WEBHOOK_STATUS: "cmsPublish",
};

export const TYPESENSE_ARCHIVE_FACET_KEYS = {
  CATEGORY: "category",
  TOURNAMENT: "tournament",
  STREAM_TITLE: "streamTitle",
  EVENTS: "events",
  PLAYERS: "players",
  TEAMS: "teams",
  RATING: "manualRating",
  ASPECT_RATIO: "aspectRatio",
  DATE_RANGE: "dateRange",
  DURATION: "duration",
  IS_BOOKMARKED: "isBookmarked",
};

export const TYPESENSE_PROMO_FACET_KEYS = {
  RATING: "rating",
  RATING_TYPE: "ratingType",
  EVENTS: "events",
  PLAYERS: "players",
  WEBHOOK_STATUS: "cmsPublish",
  PLAYBACK_SPEED: "playbackSpeed",
  ASPECT_RATIO: "aspectRatio",
  IS_MANUAL_UPLOAD: "isManualUpload",
  IS_ILLUSTO_CLIP: "isIllustoClip",
};

export const TYPESENSE_ARCHIVE_SPORTS_FACET_KEYS = {
  TOURNAMENT: "tournament",
  PLAYERS: "players",
  TEAMS: "teams",
};

export const TYPESENSE_FACET_TYPES = {
  RADIO: "radio",
  CHECKBOX: "checkbox",
  DATE_RANGE: "dateRange",
  NUMBER_RANGE: "numberRange",
  BOOLEAN: "boolean",
};

export const TYPESENSE_FACET_TYPE_MAP = {
  status: TYPESENSE_FACET_TYPES.RADIO,
  dateRange: TYPESENSE_FACET_TYPES.DATE_RANGE,
  sortBy: TYPESENSE_FACET_TYPES.RADIO,
  aspectRatio: TYPESENSE_FACET_TYPES.RADIO,
  tvChannel: TYPESENSE_FACET_TYPES.CHECKBOX,
  tvShow: TYPESENSE_FACET_TYPES.CHECKBOX,
  tournamentName: TYPESENSE_FACET_TYPES.CHECKBOX,
  teams: TYPESENSE_FACET_TYPES.CHECKBOX,
  players: TYPESENSE_FACET_TYPES.CHECKBOX,
  events: TYPESENSE_FACET_TYPES.CHECKBOX,
  isBookmarked: TYPESENSE_FACET_TYPES.RADIO,
  playbackSpeed: TYPESENSE_FACET_TYPES.RADIO,
  cmsPublish: TYPESENSE_FACET_TYPES.RADIO,
  isManualUpload: TYPESENSE_FACET_TYPES.BOOLEAN,
  isIllustoClip: TYPESENSE_FACET_TYPES.BOOLEAN,
  isIllustoTemplate: TYPESENSE_FACET_TYPES.BOOLEAN,
  rating: TYPESENSE_FACET_TYPES.CHECKBOX,
  ratingType: TYPESENSE_FACET_TYPES.RADIO,
  category: TYPESENSE_FACET_TYPES.CHECKBOX,
  streamTitle: TYPESENSE_FACET_TYPES.CHECKBOX,
  manualRating: TYPESENSE_FACET_TYPES.CHECKBOX,
  isManual: TYPESENSE_FACET_TYPES.BOOLEAN,
  isRollbacked: TYPESENSE_FACET_TYPES.BOOLEAN,
  isTagged: TYPESENSE_FACET_TYPES.BOOLEAN,
  isUntagged: TYPESENSE_FACET_TYPES.BOOLEAN,
  isDraft: TYPESENSE_FACET_TYPES.BOOLEAN,
  isAddedToClipsPage: TYPESENSE_FACET_TYPES.BOOLEAN,
  sharedWorkspaces: TYPESENSE_FACET_TYPES.RADIO,
  tournament: TYPESENSE_FACET_TYPES.CHECKBOX,
  clipLanguage: TYPESENSE_FACET_TYPES.RADIO,
  isDatafeedClip: TYPESENSE_FACET_TYPES.BOOLEAN,
  duration: TYPESENSE_FACET_TYPES.NUMBER_RANGE,
};

export const CONSTANT_STREAM_FACETS = {
  sortBy: {
    total: 2,
    values: [
      {
        highlighted: "Earliest",
        value: {
          field: "createdAt",
          order: -1,
        },
      },
      {
        highlighted: "Oldest",
        value: {
          field: "createdAt",
          order: 1,
        },
      },
    ],
  },
  dateRange: {},
};

export const CONSTANT_CLIP_FACETS = {
  sortBy: {
    total: 4,
    hideIfResultsEmpty: true,
    values: [
      {
        highlighted: "Time sequence (Descendant)",
        value: {
          field: "startTime",
          order: -1,
        },
      },
      {
        highlighted: "Time sequence (Ascendant)",
        value: {
          field: "startTime",
          order: 1,
        },
      },
      {
        highlighted: "Recent first",
        value: {
          field: "createdAt",
          order: -1,
        },
      },
      {
        highlighted: "Oldest first",
        value: {
          field: "createdAt",
          order: 1,
        },
      },
    ],
  },
  duration: {},
};

export const CONSTANT_ARCHIVE_FACETS = {
  dateRange: {},
  duration: {},
};

export const TYPESENSE_FACET_MAP = {
  category: { title: "Categories" },
  aspectRatio: { title: "Aspect ratio" },
  status: {
    title: "Status",
    labels: {
      0: "All",
      ...STREAM_STATUS_DISPLAY_MAP,
    },
  },
  dateRange: { title: "Date range" },
  sortBy: { title: "Sort by" },
  tvChannel: { title: "TV channels" },
  tvShow: { title: "TV shows" },
  teams: { title: "Teams" },
  events: { title: "Events" },
  players: { title: "Players" },
  tournamentName: { title: "Tournaments" },
  isBookmarked: { title: "Clips", labels: { true: "Bookmarked", false: "Non-bookmarked" } },
  rating: { title: "Rating" },
  ratingType: { title: "Rating type", labels: { manual: "Manual", ai: "AI" } },
  cmsPublish: { title: "Webhook status", labels: { true: "Published", false: "Unpublished" } },
  isManualUpload: { title: "User uploaded clips" },
  isIllustoClip: { title: "Advanced editor" },
  isIllustoTemplate: { title: "Template" },
  streamTitle: { title: "Streams" },
  manualRating: { title: "Rating" },
  isManual: { title: "Manual clips" },
  isRollbacked: { title: "Rollbacked clips" },
  isTagged: { title: "Tagged clips" },
  isUntagged: { title: "Untagged clips" },
  isDraft: { title: "Saved clips" },
  isAddedToClipsPage: { title: "Added to clips page" },
  sharedWorkspaces: { title: "Workspaces", altTitle: "Workspace" },
  tournament: { title: "Tournaments" },
  clipLanguage: { title: "Clip audios" },
  isDatafeedClip: { title: "Datafeed clips" },
  playbackSpeed: { title: "Playback speed" },
  duration: { title: "Duration (in seconds)" },
};

export const TYPESENSE_DEFAULT_VISIBLE_FACET_OPTION_COUNT = 10;

export const TYPESENSE_FACET_REQUEST_MAPPING = {
  tvChannel: "tvChannelId",
  tvShow: "tvShowId",
  tournamentName: "tournaments",
  sharedWorkspaces: "sharedWorkspace",
  streamTitle: "streamId",
};

export const TYPESENSE_SESSION_STORAGE_KEY = "typesense:selectedFilters:";

export const TYPESENSE_DEFAULT_CATEGORY_COUNT_LIMIT = 170;

export const TYPESENSE_DEFAULT_WORKSPACE_COUNT_LIMIT = 40;
